import { HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import {
  EStatusItemLoteEnum,
  StatusItemLoteMap,
} from "../../enums/EStatusItemLoteEnum";
import { EColumnType } from "../../../../shared/importacao-lote/components/table/EColumnType";
import { EImportacaoType } from "../../../../shared/importacao-lote/components/table/EImportacaoType";
import { ILoteDetalhes } from "../../../../shared/importacao-lote/dto/ILoteDetalhes";
import { EStatusLoteEnum } from "../../../../shared/importacao-lote/enums/EStatusLoteEnum";
import cancelarImportacaoLote from "../../../../shared/importacao-lote/utils/cancelar-importacao";
import { FilterService } from "../../../../shared/importacao-lote/utils/filter.service";
import { FormField } from "../../../../shared/interfaces/FormField";
import { HttpService } from "../../../../shared/services/http/http-client.service";
import { abrirModalConfirmarCadastro } from "../../../importacao-lote/utils/abrir-modal-confirmar-cadastro";
import { OrigemImportacaoService } from "../../../importacao-lote/utils/origem-importacao.service";

@Component({
  selector: "ngx-validar-importacao-funcionario",
  templateUrl: "./validar-importacao.component.html",
  styleUrls: ["./validar-importacao.component.scss"],
})
export class ValidarImportacaoComponent implements OnInit, OnDestroy {
  public urlGet = "";
  public urlLembrete = "";
  public loteDetalhes: ILoteDetalhes = null;
  public loteId: number = null;
  public filters: HttpParams = new HttpParams();
  public breadcrumbPath: { label: string; link?: string }[];
  public showTable: boolean = null;
  public dadosImportacao: {
    fileName: string;
    total: number;
    imported: number;
    status: "success" | "processing" | "error"; // Adiciona status para determinar o estilo
    buttonTitle?: string;
  } = null;
  public disabledButtons = false;
  private intervalId: any;
  private subscriptions: Subscription = new Subscription();
  public enum = EStatusItemLoteEnum;
  public enumMap = StatusItemLoteMap;
  public EImportacaoType = EImportacaoType.FUNCIONARIO;
  public titleButtonContinuar: string;
  public emitirCartao: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private router: Router,
    private dialogService: NbDialogService,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private origemService: OrigemImportacaoService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.spinnerService.show();
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.loteId = params.params.loteId;
      this.spinnerService.hide();
    });

    this.emitirCartao = this.origemService.getEmitirCartao(
      this.origemService.getOrigemImportacao()
    );

    this.titleButtonContinuar = this.emitirCartao === "SIM" ? "CONTINUAR" : "FINALIZAR";

    this.breadcrumbPath = [
      { label: "Lote ID " + this.loteId },
      {
        label: "Importação",
        link: `/pages/${
          this.router.url.split("/")[2]
        }/importar-arquivo?loteId=${this.loteId}`,
      },
      { label: "Revisar" },
    ];

    this.urlGet = `/importacao-funcionario/${this.loteId}/itens-lote`;
    this.urlLembrete = `/importacao-funcionario/${this.loteId}/itens-lote-funcionario/erro-validacao`;
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.loteDetalhes = response;
      }
    );
    this.getDados();
    this.filter({});

    this.intervalId = setInterval(() => {
      if (!this.showTable) {
        this.getDados();
      }
    }, 10000);
  }

  ngOnDestroy(): void {
    this.destroyInterval();
  }

  destroyInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.subscriptions.unsubscribe();
  }

  public cargaFormFields: FormField[] = [
    {
      name: "nome",
      label: "Nome",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
    {
      name: "cpf",
      label: "CPF",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
    {
      name: "matricula",
      label: "Matrícula",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
    {
      name: "email",
      label: "Email",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
    {
      name: "telefone",
      label: "Telefone",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
    {
      name: "codigoCentroDeCusto",
      label: "Centro de Custo",
      placeholder: "Digite",
      type: "text",
      value: "",
    },
  ];

  public tableColumns = [
    { prop: "nome", name: "Nome", type: EColumnType.STRING },
    { prop: "cpf", name: "CPF", type: EColumnType.CPF_CNPJ },
    { prop: "matricula", name: "Matrícula", type: EColumnType.STRING },
    { prop: "email", name: "Email", type: EColumnType.STRING },
    { prop: "telefone", name: "Telefone", type: EColumnType.PHONE },
    { prop: "nomeMae", name: "Nome da mãe", type: EColumnType.STRING },
    { prop: "dataNascimento", name: "Nascimento", type: EColumnType.STRING },
    { prop: "codigoCentroDeCusto", name: "Centro de Custo", type: EColumnType.STRING },
  ];

  getDados() {
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.validateData(response);
      }
    );
  }

  validateData(lote: ILoteDetalhes) {
    if (lote) {
      if (
        !(
          EStatusLoteEnum[lote.status] === EStatusLoteEnum.CRIADO ||
          EStatusLoteEnum[lote.status] === EStatusLoteEnum.EM_EXECUCAO ||
          EStatusLoteEnum[lote.status] === EStatusLoteEnum.EM_PROCESSAMENTO ||
          EStatusLoteEnum[lote.status] === EStatusLoteEnum.EM_VALIDACAO
        )
      ) {
        this.destroyInterval();
        this.loteId = lote.id;
        this.showTable = true;
        this.disabledButtons = false;
        this.http.doGet(
          `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
          "",
          (response) => {
            this.loteDetalhes = response;
          }
        );
        this.filter({});
      } else {
        this.dadosImportacao = {
          fileName: lote.nomeArquivo,
          total: lote.totalRegistros,
          imported:
            lote.status.toString() === "EM_PROCESSAMENTO"
              ? lote.qtdProcessadasProcessamento
              : lote.qtdProcessadasValidacao,
          status: "processing",
        };
        this.disabledButtons = true;
        this.showTable = false;
      }
    } else {
      this.showTable = true;
    }
  }

  filter(event) {
    const properties = this.cargaFormFields.map((a) => a.name);
    if (event.telefone) {
      event.telefone = event.telefone.replace(/\D/g, "");
    }
    this.filters = this.filterService.generateFilter(event, properties);
    this.filters = this.filters.append("status", "VALIDO");
  }

  onCancel() {
    cancelarImportacaoLote(
      this.dialogService,
      this.spinnerService,
      this.notifications,
      this.router,
      this.http,
      this.loteDetalhes,
      this.EImportacaoType
    );
  }

  onContinue() {
    if (this.emitirCartao === "SIM") {
      this.router.navigate(["validar-pagamento-cartao"], {
        relativeTo: this.activatedRoute.parent,
        queryParams: { loteId: this.loteId },
      });
    } else {
      this.openConfirmModal();
    }
  }

  openConfirmModal() {
    // caso não emita cartão, finaliza o processo
    abrirModalConfirmarCadastro(
      this.dialogService,
      {
        emitirCartao: this.emitirCartao,
        loteDetalhes: this.loteDetalhes,
        textButtonConfirm: 'FINALIZAR',
      },
      () => {
        this.spinnerService.show();
        this.http.doPost(
          `/importacao-funcionario/${this.loteId}/processar-pagamento`,
          {
            valorSaldoGlobal: Number(0),
            valorSaldoConta: Number(0),
            valorSaldoRecebiveis: Number(0),
            valorPrimeiraVia: Number(0),
          },
          (_response: any) => {
            this.spinnerService.hide();
            this.router.navigate([`/pages/${this.router.url.split("/")[2]}/importacao-finalizada`], {
              relativeTo: this.activatedRoute,
              queryParams: { loteId: this.loteId },
            });
          },
          (_error: any) => {
            this.spinnerService.hide();
            this.notifications.error(
              "Ocorreu um erro ao finalizar: " + _error.toString()
            );
          }
        );
      },
      (_error) => {
        this.spinnerService.hide();
      }
    );
  }
}
